import { Router, ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';

import { ProgrammingUtilsService as Utils } from './../../../common/services/utils.service';
import { DeviceEvent } from './../../../common/interfaces/event.interface';
import { SharedProgrammingService, CommonProgrammingContext } from './../../../common/services/shared-programming.service';
import { ProgrammingUtilsService as Util } from '../../../common/services/utils.service';
import { QuickstartProgrammingService } from '../../services/quickstart-programming.service';
import { BaseRoutingComponent } from '../../../common/base-routing/base-routing.component';


import { LightsService, LightsProgrammingContext } from '../services/lights.service';

import { Command } from '../../../common/params/interfaces/command.interface';
import { Parameter } from '../../../common/params/interfaces/parameter.interface';

import { Light } from '../services/interfaces/light.interface';
import { Event } from '../../../common/interfaces/event.interface';

@Component({
  selector: 'prg-select-action',
  templateUrl: './select-action.component.html',
  styleUrls: ['./select-action.component.less']
})
export class SelectActionComponent extends BaseRoutingComponent implements OnInit {

  trigger: Observable<any>;
  light: Observable<Light>;
  ready: Observable<boolean>;

  private _commands: Observable<Command[]>;
  private _simpleCommands: Observable<Command[]>;
  private _parameterCommands: Observable<Command[]>;

  constructor(
    protected router: Router,
    private route: ActivatedRoute,
    private shared: SharedProgrammingService,
    protected store: Store<{
      lightsProgramming: LightsProgrammingContext,
      sharedProgramming: CommonProgrammingContext
    }>,
    private lights: LightsService,
    private utils: Util,
    private quickstarts: QuickstartProgrammingService
  ) {
    super();

    this.route.params.subscribe((params: { id: string }) => {
      this.lights.setActionLight(parseInt(params.id));
    });

    this.trigger = this.store.select(s => s.lightsProgramming.trigger.event);
    this.light = this.store.select(s => s.lightsProgramming.action.light);
    this.ready = this.shared.isReady;

    this._commands = this.store.select(s => s.lightsProgramming.action.commands)
      .filter(c => !!c)
      .distinctUntilChanged(Util.distinct)
      .map((c: any) => c.map(this._setParameterDefaults));

    this._simpleCommands = this._commands.map(c => c.filter(c => !c.params || c.params.every(p => p.type === 'HIDDEN')));
    this._parameterCommands = this._commands.map(c => c.filter(c => !!c.params && c.params.some(p => p.type !== 'HIDDEN')));
  }

  ngOnInit() {
  }

  private _setParameterDefaults = (command: Command): Command => {
    if (!!command.params) {
      command.params = command.params.map(p => {
        p._value = p._value || p.value || p.default || p.low || p.minimum || 0;
        p._display = (typeof p._value == 'string') ? p._value : p._value.toString();

        return p;
      });
    }

    return command;
  }

  setCommand(command: Command, params?: Parameter[]) {
    let allParams: Parameter[] = [];
    allParams.concat(command.params, params);
    this.lights.setActionCommand(command, allParams);
  }
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-lights/select-action/select-action.component.ts